<template>
  <div>
    <custom-dialog
      width="550px"
      :showClose="false"
      :close-on-press-escape="false"
      v-if="visibleObj.pricingChargeDialog"
      :visible="visibleObj.pricingChargeDialog"
      @close="dialogVisible('pricingChargeDialog')">
      <template slot="header">
        <div class="charge_header">
          <div class="charge_header_title">收费</div>
          <div class="btn-warp-tips" v-if="computedOrderYbScope.ybScope == 3 || (computedOrderYbScope.ybScope == 2 && payFrom.type == 1)">【{{computedOrderYbScope.text}}】{{ computedOrderYbScope.tips }}</div>
          <div class="btn-warp-tips" v-else>
            <span v-if="computedOrderPhyRisk.numRiskFlag">单张理疗处方项目数超过4个，可能存在医保合规风险；</span>
            <span v-if="computedOrderPhyRisk.timesFlag">单个理疗项目疗程次数超过1次，可能存在医保合规风险；</span>
          </div>
        </div>
      </template>
      <div class="charge-warp" slot="content" v-loading="loading" :element-loading-text="loadingText">
        <custom-button
          slot="footer"
          v-if="showCancelPayBtn && loading"
          type="info"
          style="width: 100px;position:absolute;top: 230px;left: 50%;transform: translateX(-50%);z-index: 9999999"
          @click="cancelPayingStatusHandle">
          取消支付
        </custom-button>
        <div class='price-warp'>
          <div class="price_box">
            <div class="price_box_center">
              <div class="price_pending">待收：¥{{ payFrom.waitTotal }}</div>
              <div class="price_receivable">应收：¥ {{ payFrom.realPay }}</div>
            </div>
          </div>
        </div>
        <div class="payWay-warp">
          <el-button
            v-for="item in PAY_WAY"
            :key="item.value"
            :class="payFrom.type == item.value ? 'payWay-item active' : 'payWay-item'"
            :disabled="item.disabled"
            @click="changeType(item.value)">
            {{ item.label }}
          </el-button>
        </div>
        <div class="cash-warp" v-if="payFrom.type && ((payFrom.type != 12) || (payFrom.type == 12 && !['', null, undefined].includes(vipCard.vipCardNumber)))">
          <el-input
            :class="{ input_vipCard: payFrom.type == 12 }"
            v-model.trim="payFrom.casreceiptsh"
            placeholder="请输入金额"
            :disabled="payFrom.type == '1' || payFrom.type == '14'"
            @input="calculateChange">
            <template slot="prepend">{{ casreceiptshStr }}</template>
            <template slot="append" v-if="payFrom.type == '2' && payFrom.changeMoney > 0">找零 {{ payFrom.changeMoney }}</template>
            <template slot="append" v-if="payFrom.type == 12">余额：￥{{ vipCard.balance }}</template>
          </el-input>
        </div>
        <div class="btn-warp">
          <div class="charge_footer_left">
            <div class="charge_btn" v-if="!['', null, undefined].includes(vipCard.vipCardNumber) && !isDisabled" @click="unBindVipCard">解绑至尊卡</div>
          </div>
          <div class="charge_footer_right">
            <div class="charge_btn" @click="cancelCharge">取消</div>
            <div class="charge_btn charge_btn_primary" v-if="(payFrom.type != 12 && payFrom.type != 14) || (payFrom.type == 14 &&  offLineObj ) || (payFrom.type == 12 && !['', null, undefined].includes(vipCard.vipCardNumber))" @click="charge">收费</div>
            <div class="charge_btn charge_btn_primary" v-if="payFrom.type == 12 && ['', null, undefined].includes(vipCard.vipCardNumber) || (payFrom.type == 14 && !offLineObj)" @click="toVipCardScan">扫描</div>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </custom-dialog>
    <VipCardScan ref="vipCardScan" @scanSuccess="vipCardScanSuccess"></VipCardScan>
    <VipCardDiscountConfirm ref="vipCardDiscountConfirm" @confirm="vipCardDiscountConfirm"></VipCardDiscountConfirm>
    <YbScan ref="ybScan" @scanSuccess="ybScanSuccess"></YbScan>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomInput from '@/components/CustomInput'
import VipCardScan from '@/components/VipCard/VipCardScan.vue'
import VipCardDiscountConfirm from '@/components/VipCard/VipCardDiscountConfirm.vue'
import { Utils } from '@/utils/utils'
import { isEmptyArray, isNull, dictText, debounce, isNullObj, validParams, msgboxWarning } from '@/utils/validateBase'
import { payDTO, orderDTO, CommonDTO } from '@/DTO/index'
import { positiveNum } from '@/utils/regexp'
import { getVipCardInfo, bindVipCard, updateVipCardDiscount, unBindVipCard } from "@/api/member"
import { unbindCoupon } from '@/api/coupon'
import YbScan from '@/components/ybScan/ybScan.vue'

export default {
  // 定义引入的组件
  components: {
    CustomDialog,
    CustomInput,
    VipCardScan,
    VipCardDiscountConfirm,
    YbScan,
  },
  props: {
    visibleObj: {
      type: Object,
      default: () => { return {} }
    },
    dialogObj: {
      type: Object,
      default: () => { return {} }
    },
    showCancelPayBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orderPayNumber: '',
      loading: false,
      orderId: '',
      PAY_WAY: [],
      isBargainBtn: true, //议价按钮
      isRounding: false,//是否凑整
      isZero: false,//是否抹零
      isDisabled: false,
      btnsDisabled: false,
      payFrom: {
        paid: 0,//已付
        realPay: 0,//应收
        waitTotal: 0,//待收
        totalPrice: 0,//总价
        casreceiptsh: 0, //实际收费
        // receivable: 0, //剩余应收余额
        type: '', //支付方式
        discount: 100, //议价折扣
        changeMoney: 0, //找零
        discountPrice: 0, //优惠金额
        amount: 0, //整单折后金额
      },
      payList: [],
      registerPrice: '',//挂号费
      isExist: '',//是否存在有效订单
      prePayRecordList: [],//预支付记录
      loadingText: '',
      version: '',
      vipCard: {
        vipCardNumber: '',
        status: '',
        discountRate: 100,
        balance: 0,
        discountStatus: 1
      },
      offLineObj:null
    }
  },
  //变量监听
  watch: {},
  computed: {
    formatNumber() {
      let self = this;
      return function (val) {
        // 对计算属性进行传参
        if (val) {
          return self.$toFixed(val);
        }
      };
    },
    casreceiptshStr() {
      let label = ''
      this.PAY_WAY.forEach(item => {
        if (item.value == this.payFrom.type) {
          label = item.label
        }
      })
      return label;
    },
    computedOrderYbScope(){
      let list = this.dialogObj.diagnosisList
      let obj = {
        ybScope:'',
        tips:'',
        text:''
      }
      if(!isEmptyArray(list)){
        let notList = [] //不可刷医保
        let gzList = [] //个账
        let tcList = [] //统筹
        list.forEach(v=>{ 
          if(isNull(v.ybScope) || isNull(v.diagnoseCode) || v.ybScope == 3){
            notList.push(v.diagnoseName)
          }
          if(v.ybScope == 2){
            gzList.push(v.diagnoseName)
          }
          if(v.ybScope == 1){
            tcList.push(v.diagnoseName)
          }
        })
        if(!isEmptyArray(notList)){
          obj.ybScope = 3
          obj.tips = '不可刷医保'
          obj.text = notList.join(',')
        }else if(!isEmptyArray(gzList)){
          obj.ybScope = 2
          obj.tips = '仅个账'
          obj.text = gzList.join(',')
        }else if(!isEmptyArray(tcList)){
          obj.ybScope = 1
          obj.tips = '可统筹'
          obj.text = tcList.join(',')
        }
      }
      return obj
    },
    computedOrderPhyRisk(){
      let recipesList = this.dialogObj.recipesList || []
      let numRiskFlag = false
      let timesFlag = false
      numRiskFlag = recipesList.some(v1=>{ return v1.recipeType == '3' && v1.items.length > 4 })
      timesFlag = recipesList.some(v1=>{ 
        return v1.recipeType == '3' && v1.items.some(v2=>{ return v2.physioExtendJson && v2.physioExtendJson.soldNum > 1 }) })
      return {numRiskFlag,timesFlag }
    },
  },
  // 页面初始化
  async created() {
    let payWay = await CommonDTO.getPayWay()
    this.PAY_WAY = payWay.filter(v => { return v.value != '7' })
    this.$emit('showOrHideCancelPayBtn', false)
    let { orderId, registerPrice } = this.dialogObj
    this.orderId = orderId
    this.registerPrice = registerPrice
    this.updateVipCardInfo()

    this.calculateWaitTotal()
  },
  // 页面DOM加载完成
  mounted() { },
  filters: {
    filterPayWay(val, PAY_WAY) {
      return dictText(val, PAY_WAY)
    },
    filterPayTime(val) {
      if (!isNull(val)) return Utils.timeFormat(val, 'yyyy-MM-DD HH:mm:ss')
    }
  },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
   * 初始化数据
   */
     async calculateWaitTotal() {
      try {
        this.loadingText = ''
        this.loading = true
        let { totalPrice } = this.dialogObj
        this.payFrom.totalPrice = totalPrice
        this.payFrom.waitTotal = totalPrice
        this.payFrom.casreceiptsh = totalPrice
        this.payFrom.realPay = totalPrice
        // 获取支付记录
        await this.getPayRecord()
      } catch (error) {
        CommonDTO.saveLogDTO({ businessType: '1', errorMsg: error.message })
      }
    },

    updateVipCardInfo () {
      if (this.dialogObj.vipCard) {
        this.vipCard.vipCardNumber = this.dialogObj.vipCard.vipCardNumber || ''
        this.vipCard.status = this.dialogObj.vipCard.status || ''
        this.vipCard.discountRate = this.dialogObj.vipCard.discountRate || 100
        this.vipCard.balance = this.dialogObj.vipCard.balance || 0
        this.vipCard.discountStatus = this.dialogObj.vipCard.discountStatus || 1
        if (this.vipCard.vipCardNumber) {
          this.payFrom.type = 12
        }
      }
    },

    /**
     * 收费
     */
    charge: debounce(function () {
      try {
        let { casreceiptsh, waitTotal, type, totalPrice, realPay } = this.payFrom
        if (isNull(type)) return this.$message.error('请选择收费方式')        
 
        if (Utils.gt(casreceiptsh, waitTotal) && type != 2) return this.$message.error('金额不能大于待收金额')

        if (this.payFrom.type == 12 && Utils.gt(casreceiptsh, this.vipCard.balance)) {
          this.$message.error('至尊卡余额不足，请选择其他收费方式')
          return
        }

        orderDTO.judeExitCtOrder({ orderId: this.orderId }).then(res => {
          if (isNull(casreceiptsh) || (waitTotal > 0 && [0, '0'].includes(casreceiptsh))) {
            return this.$message.error('金额不能为0或空')
          }
          
          this.isExist = res.data.isExist
          this.ctOrderIds = res.data.ctOrderIds
          this.loading = true
          let obj = {
            price: Utils.gt(casreceiptsh, waitTotal) ? waitTotal : casreceiptsh,
            payWay: type,
            vipCard: this.vipCard,
            offLineObj:this.offLineObj
          }
          //判断版本号是否一致，不一致提升刷新
          if (this.dialogObj.version !== res.data.version) {
            this.$message.warning({ message: '划价单已更新，请重新提交收费', duration: 1000 })
            this.dialogVisible('pricingChargeDialog')
            return
          }
          // 判断是否存在有效订单
          if (this.isExist == '0') {
            this.isDisabled = false
            let params = {
              orderId: this.orderId,
              version: this.dialogObj.version,
              couponIds: this.dialogObj.couponIds || null,
              couponMemberId: this.dialogObj.memberId || null,
            }
            params.activityNumber = this.dialogObj.activity && this.dialogObj.activity.orderGift && this.dialogObj.activity.orderGift.number || ''
            orderDTO.createOrder(params).then(orderRes => {
              if (orderRes.code == 200) {
                if(orderRes.data.realPrice != this.payFrom.realPay){
                  this.loading = false
                  this.dialogVisible('pricingChargeDialog')
                  this.$emit('chargeSuggestion',orderRes.data.realPrice)
                }else{
                  obj.ctOrderIds = orderRes.data.ctOrderIds
                  this.isDisabled = true
                  this.$emit('updateData', obj)
                }
              } else {
                this.loading = false
                this.isDisabled = false
              }
            })
          } else {
            this.prePayRecords()
            this.isDisabled = true
            obj.ctOrderIds = this.ctOrderIds
            this.$emit('updateData', obj)
          }
        }).catch(() => {
          this.loading = false
        })
      } catch (error) {
        this.loading = false
      }

    }, 1000, true),
    // 至尊卡扫码
    toVipCardScan () {
      if(this.payFrom.type == 12){
        this.$refs['vipCardScan'].open()
      }else if(this.payFrom.type == 14){
        this.$refs['ybScan'].open()
      }

    },
    async vipCardScanSuccess (code) {
      if (code) {
        const res = await getVipCardInfo({ vipCardNumber: code })

        if (res.code === 200) {
          if ([2, 3, 4].includes(res.data.status)) {
            let text = ''
            switch (res.data.status) {
              case 2:
                text = '该至尊卡已过期，暂不可用!'
                break
              case 3:
                text = '该至尊卡已被冻结，暂不可用!'
                break
              case 4:
                text = '该至尊卡未激活，暂不可用!'
                break
            }
            this.$confirm(text, '提示', {
              showConfirmButton: false,
              cancelButtonText: '关闭',
              type: 'warning'
            }).then(() => {}).catch(() => {})
            return
          }

          this.vipCard.vipCardNumber = res.data.vipCardNumber || ''
          this.vipCard.status = res.data.status || ''
          // this.vipCard.discountRate = res.data.discountRate || 100
          this.vipCard.balance = res.data.balance || 0
          this.vipCard.discountStatus = 1
          this.bindVipCard()
        }
      }
    },
    vipCardDiscountConfirm (type) {
      if (type === 2) {
        if ([0, '0', '', null, undefined].includes(this.payFrom.paid)) {
          this.vipCard.discountStatus = 2
        } else {
          this.vipCard.discountStatus = 1
        }
      } else {
        this.vipCard.discountStatus = 1
      }
      this.bindVipCard()
    },
    async bindVipCard () {
      if (this.vipCard.discountStatus === 2 && !isNull(this.dialogObj.couponIds)) {
        await unbindCoupon({
          orderId: this.orderId,
          couponIds: this.dialogObj.couponIds,
          memberId: this.dialogObj.memberId
        }).then(res => {
          if (res.code === 200) {
            this.dialogObj.couponIds = null
            this.dialogObj.memberId = null
          }
        })
      }
      const res = await bindVipCard({
        orderId: this.orderId,
        vipCardNumber: this.vipCard.vipCardNumber,
        discountStatus: this.vipCard.discountStatus
      })
      if (res.code === 200 && res.data) {
        if (this.vipCard.discountStatus === 2) {
          if (![0, '0', null, undefined].includes(this.payFrom.discountPrice)) {
            this.showText = ''
            this.isZero = false;
            this.isRounding = false
            this.payFrom.discountPrice = 0
            await this.calculateWaitTotal()
          }
          this.$emit('updatePage')
        }
      } else {
        this.$message.error(res.msg)
        this.vipCard = {
          vipCardNumber: '',
          status: '',
          discountRate: 100,
          balance: 0,
          discountStatus: 1
        }
      }
    },
    async unBindVipCard () {
      const res = await unBindVipCard({
        orderId: this.orderId,
        vipCardNumber: this.vipCard.vipCardNumber
      })
      if (res.code === 200 && res.data) {
        this.vipCard = {
          vipCardNumber: '',
          status: '',
          discountRate: 100,
          balance: 0,
          discountStatus: 1
        }
        this.$emit('updatePage')
      }
    },
    /**
  * 计算折扣后各项价格
  * @param {*} obj 支付对象参数
  */
    countDiscount(obj) {
      let { discountPrice, amount, drugAmount, totalPrice, discount } = obj
      this.payFrom.discount = this.$bigNumber(discount, '*', 100)
      // 整单折扣
      let tempTotal = this.$bigNumber(totalPrice, '-', isNull(this.registerPrice) ? 0 : this.registerPrice)
      amount = this.$bigNumber(this.$bigNumber(tempTotal, '*', discount), '/', 100, 2)
      this.payFrom.amount = amount
      this.payFrom.drugAmount = drugAmount
      this.payFrom.discountPrice = discountPrice
      this.payFrom.receivable = totalPrice
      this.payFrom.discount = discount
    },
    /**
    * 计算找零
    */
    calculateChange(val) {
      // 校验输入的为正数
      let bol = validParams(val, positiveNum, '请输入正数')
      if (!bol) {
        this.payFrom.casreceiptsh = ''
        return
      }
      if (this.payFrom.type == '2') {
        if (Utils.gt(this.$bigNumber(val, '-', this.payFrom.waitTotal), 0)) {
          this.payFrom.changeMoney = this.$bigNumber(val, '-', this.payFrom.waitTotal)
        } else {
          this.payFrom.changeMoney = 0
        }
      } else {
        if (Utils.gt(val, this.payFrom.waitTotal)) {
          this.$message.error('输入金额不能大于应收金额')
          this.payFrom.casreceiptsh = this.payFrom.waitTotal
        }
      }

    },
    /**
     * 切换支付方式
     */
    changeType(val) {
      this.payFrom.type = val;
      this.calculateChange(this.payFrom.casreceiptsh)
      if (val == 1) {
        this.payFrom.casreceiptsh = this.payFrom.waitTotal
      }
    },
    /**
    * 关闭
    */
    dialogVisible(name) {
      this.$emit("close", name);
    },

    /**
     * 取消收费 判断是否需要解库
     */
    cancelCharge() {
      this.$emit('cancelCtOrder')
    },
    /**
    * 获取支付记录并查询是否存在有效订单
    */
    getPayRecord() {
      return new Promise(async (resolve, reject) => {
        await orderDTO.judeExitCtOrder({ orderId: this.orderId }).then(res => {
          let { code, data } = res
          if (code == 200) {
            this.isExist = data.isExist
            this.isDisabled = data.isExist == '1' ? true : false
            this.ctOrderIds = data.ctOrderIds
            this.payFrom.realPay = isNull(data.shouldIncomeMoney) ? this.payFrom.realPay : data.shouldIncomeMoney
            this.payList = data.payRecords.filter(item => { return item.paySuccess == '1' })
            if (isEmptyArray(this.payList)) {
              this.PAY_WAY.forEach(item => {
                if (item.value == '1' || item.value == '14') item.disabled = false
              })
              if(this.computedOrderYbScope.ybScope == 3){
                this.PAY_WAY.find(v=>{ return v.value == 1}).disabled = true
                this.PAY_WAY.find(v=>{ return v.value == 14}).disabled = true
              }
              this.loading = false
            } else {
              let payPrice = '0.00'
              if (this.vipCard.vipCardNumber) {
                this.payFrom.type = 12
              } else {
                this.payFrom.type = '2'
              }
              this.payList.forEach(item => {
                this.PAY_WAY.forEach(item => {
                  if (item.value == '1' || item.value == '14') item.disabled = true
                })
                payPrice = this.$bigNumber(payPrice, '+', item.payPrice)
              })
              this.payFrom.paid = payPrice;
              this.isBargainBtn = false;
              this.payFrom.waitTotal = this.$bigNumber(this.payFrom.realPay, '-', this.payFrom.paid)
              this.payFrom.casreceiptsh = this.payFrom.waitTotal
              this.loading = false
            }
            if (this.isExist == '1') this.prePayRecords() //支付记录为空，查询预支付记录
            resolve(res)
          } else {
            this.loading = false
          }
          
        }).catch((error) => {
          this.loading = false
          CommonDTO.saveLogDTO({ businessType: '1', errorMsg: error.message })
        })
      })
    },
    /**
     * 获取预支付记录
     */
    prePayRecords() {
      return new Promise(async (resolve, reject) => {
        let { code, data } = await payDTO.prePayRecords({ orderId: this.orderId })
        if (code == 200) {
          resolve()
          this.prePayRecordList = data.prePayRecords || []
          let obj = {}
          // obj = data.prePayRecords && data.prePayRecords.find(item=>{return item.payWay=='3' && item.paySuccess=='3' })
          obj = data.prePayRecords && data.prePayRecords.at(-1)

          // 存在好码齐支付中的状态
          if (!isNullObj(obj) && !isNull(obj.queueId) && obj.payWay == '3' && obj.paySuccess == '3') {
            this.orderPayNumber = obj.orderPayNumber || ''
            this.$emit('changePrePayDate', obj.prePayDate)
            this.loading = true
            this.loadingText = '正在查询上次支付记录的结果，请稍候'
            this.$emit('getConsumeMessage', obj.queueId)
          } else {
            this.$emit('changePrePayDate', +new Date())
          }
        } else {
          this.loading = false
        }
      }).catch(() => {
        this.loading = false
      })

    },

    // 取消支付中状态
    cancelPayingStatusHandle() {
      msgboxWarning(this, {
        message: "支付出现问题，请先确认是否已扣款。若已扣款，请耐心等待支付结果通知。若未扣款，您可以取消此次支付。",
        confirmButtonText: "确定取消支付",
        cancelButtonText: "关闭弹窗",
        confirmFn: async () => {
          const params = {
            orderPayNumber: this.orderPayNumber || '',
            type: "1"
          }
          const res = await payDTO.cancelPayingStatus(params)
          if (res.code == 'success') {
            this.$message.success('取消成功')
            this.loading = false
            this.loadingText = ''
            this.$emit('showOrHideCancelPayBtn', false)
            this.$emit('closeInterval')
          } else {
            this.$message.error('取消失败')
          }
        },
        cancelFn: () => {
        }
      });
    },
    // 医保结算扫码
    ybScanSuccess (value) {
      console.log(value);
      let obj = isNull(value) ? {} : JSON.parse(value)
      //医保支付 = 基金支付 + 个账支出 + 钱包 + 共济
      let price = 0
      if(isNull(obj.ima_setl) && isNull(obj.ima_mdtrt)){
        // 未走共济
        price = this.$bigNumber(price, '+', obj.fund || 0)
        price = this.$bigNumber(price, '+', obj.wltpay || 0)
        price = this.$bigNumber(price, '+', obj.acct || 0)
      }else{
        // 走共济 
        price = this.$bigNumber(price, '+', obj.fund || 0)
        price = this.$bigNumber(price, '+', obj.ima_acct || 0)
        price = this.$bigNumber(price, '+', obj.wltpay || 0)
        price = this.$bigNumber(price, '+', obj.acct || 0)
      }
      this.offLineObj = obj
      this.payFrom.casreceiptsh = price
    }
  },
}
</script>
<style lang="less" scoped>
.charge_header {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 24px;
  height: 48px;
  border-bottom: 1px solid #EBEAEE;
}

.charge_header_title {
  font-size: 16px;
  color: #1F2329;
  flex-shrink: 0;
}

/deep/.dialog-content {
  padding: 0;
}

.btn-warp-tips{
  margin: 0 0 0 6px;
  font-weight: 400;
  font-size: 14px;
  color: #FE8F1F;
}

.charge-warp {
  padding: 28px 24px;

  .price-warp {
    text-align: center;
    // padding: 24px 0 16px 0;
    padding-bottom: 16px;
    justify-content: center;
    border-bottom: 1px solid #EBEAEE;

    .price-top {
      display: flex;
      justify-content: space-between;

      .showText {
        color: #667182;
        font-size: 14px;
      }

      .el-button--mini {
        padding: 7px 10px;
      }

      .price-total {
        font-size: 22px;
        color: orange;
        font-weight: bold;
        margin-right: 30px;
      }
    }

    .residue-warp {
      margin-top: 4px;
      font-weight: 500;
      font-size: 14px;
      color: #1F2329;
      margin-left: 5px;
    }


    .bargain-btn {
      position: absolute;
      top: 10px;
      right: 20px;
    }
  }

  .payWay-warp {
    // display: flex;
    // flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(3, 145px);
    // grid-template-rows: repeat(3, 40px);
    padding-top: 24px;
    row-gap: 8px;
    justify-content: space-between;

    /deep/.el-button {
      margin: 0;
      height: 40px;
    }

    // .payWay-item {
    //     width: 145px;
    //     height: 40px;
    //     // margin-bottom: 8px;
    //     // margin-right: 8px;
    //     box-sizing: border-box;

    //     &:nth-child(3n) {
    //         margin-right: 0;
    //     }
    // }

    .active {
      border: 1px solid #4bb1fa;
      color: #4bb1fa;
    }
  }

  .cash-warp {

    /deep/.el-input-group__append,
    /deep/.el-input-group__prepend {
      background: #fff;
      color: #000;
    }

    margin-top: 10px;

    /deep/.el-input-group__prepend {
      height: 42px;
      padding: 0 36px;
    }

    /deep/.el-input__inner {
      height: 44px;
      // width: 155px;
      font-size: 17px !important;
    }
  }

  .price_box {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  .price_box_left {
    flex-shrink: 0;
    width: 120px;
  }

  .price_box_left_content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .price_box_center {
    flex-grow: 1;
  }

  .price_box_right {
    flex-shrink: 0;
    width: 120px;
  }

  .price_box_right_btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .price_box_btn {
    padding: 7px 10px;
  }

  .price_box_right_tips {
    margin: 4px 0 0 0;
    line-height: 18px;
    text-align: right;
    font-size: 12px;
    color: #667182;
  }

  .price_pending {
    line-height: 30px;
    font-weight: bold;
    font-size: 22px;
    color: orange;
  }

  .price_receivable {
    margin: 4px 0 0 0;
    font-weight: 500;
    font-size: 14px;
    color: #1F2329;
  }

  .input_vipCard /deep/ .el-input-group__append {
    color: #667182;
  }

  .detail-warp {
    color: #000;
    margin-top: 20px;
    padding-left: 20px;

    & div {
      margin-top: 10px;
    }
  }



  .hide-section {
    /deep/.el-input__inner {
      height: 0px;
    }

    opacity: 0;
  }
}

.btn-warp {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.charge_footer_left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.charge_footer_right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.charge_btn {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  height: 32px;
  font-size: 14px;
  color: #1F2329;
  background-color: #FFFFFF;
  border: 1px solid #D3D3D5;
  border-radius: 2px;
  cursor: pointer;
}

.charge_btn+.charge_btn {
  margin: 0 0 0 8px;
}

.charge_btn_primary {
  color: #FFFFFF;
  background-color: #1890FF;
  border-color: #1890FF;
}
</style>